import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCalendarWeek } from "@fortawesome/free-solid-svg-icons"

export const CalendarWeek = (props) => {
  return <FontAwesomeIcon faIcon={faCalendarWeek} {...props} />
}
